import { showError } from '@/libs/react.toastify';

/**
 * Handles API error responses and sets form errors accordingly
 */
export const handleFormError = (error, setError, options = {}) => {
  try {
    const { fieldMapping = {}, onError } = options;
    // Custom handler first
    if (onError) {
      return onError(error, setError);
    }

    const response = error?.response?.data;

    if (!response) {
      showError('There is an error on the server. Please try again later.');
      return;
    }

    const { message } = response;

    // When errors is an array → set field errors and/or show first message in toast
    if (Array.isArray(message)) {
      const firstItem = message[0];
      if (
        firstItem &&
        typeof firstItem === 'object' &&
        (firstItem.field !== undefined || firstItem.error !== undefined)
      ) {
        message.forEach(err => {
          const field = fieldMapping[err.field] ?? err.field;
          setError(field, {
            type: 'manual',
            message: err.error ?? err.message,
          });
        });
        const firstError = message[0]?.error ?? message[0]?.message;
        if (firstError && typeof firstError === 'string') {
          showError(firstError);
        }
      } else {
        const firstErrorMsg =
          typeof firstItem === 'string'
            ? firstItem
            : (firstItem?.error ?? firstItem?.message ?? response.error ?? 'Something went wrong');
        showError(firstErrorMsg);
        setError('root', { type: 'manual', message: firstErrorMsg });
      }
      return;
    }

    // When errors is NOT array → show toast only
    if (typeof message === 'string') {
      showError(message);
      return;
    }

    // When errors is null or unknown → show response message
    if (!message) {
      showError(response.message || 'Something went wrong');
      return;
    }

    // When errors is an object → show toast with first message
    if (typeof message === 'object') {
      const firstErrorMsg = Object.values(message)[0] || response.message || 'Something went wrong';

      showError(firstErrorMsg);
      return;
    }
  } catch (e) {
    console.warn(e);
  }
};

/** Reusable handler */
export const createFormErrorHandler = (setError, options = {}) => {
  return error => handleFormError(error, setError, options);
};
